import { render, staticRenderFns } from "./measure-set-point.vue?vue&type=template&id=360382a6&"
import script from "./measure-set-point.vue?vue&type=script&lang=js&"
export * from "./measure-set-point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports